export default class MirrorNfCalcs {
  constructor() {
    this._products = [];
    this._kitPossibilities = {
      sizes: ['6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18'],
      types: ['KIT', 'KIT ', 'PACK', 'PACK ', 'K', 'K ', 'P', 'P '],
    };
  }

  nfeProductList(products) {
    if (!products || products.length === 0) {
      this._products = [];
      return this._products;
    }

    this._products = JSON.parse(JSON.stringify(products));

    const list = [];
    this._products.forEach(i => {
      if (i.unit.toLowerCase() === 'kit') this.validateKit(i);

      i.baseUnitariaICMS = this.getUnitBaseICMS(i.baseICMS, i.qtdFaturada);

      if (list.length > 0) {
        let edited = false;
        list.forEach((item, index) => {
          item.baseUnitariaICMS = this.getUnitBaseICMS(item.baseICMS, item.qtdFaturada);

          if (item.codProductNf == i.codProductNf
            && item.value === i.value
            && item.baseUnitariaICMS === i.baseUnitariaICMS) {
            item.auxCount += Number(i.qtd);
            item.totalValue += Number(i.value) * Number(i.qtd);
            edited = true;
          }
        });
        if (!edited) {
          i.auxCount = Number(i.qtd);
          i.totalValue = Number(i.value) * Number(i.qtd);
          list.push(i);
        }
      } else {
        i.auxCount = Number(i.qtd);
        i.totalValue = Number(i.value) * Number(i.qtd);
        list.push(i);
      }
    });

    /** CALCULA VALOR ICMS E DO DESCONTO (SE HOUVER BASE DE baseICMS DO SQL) */
    list.forEach(item => {
      if (!item.baseUnitariaICMS) item.baseUnitariaICMS = this.getUnitBaseICMS(item.baseICMS, item.qtdFaturada);
      item.discountValue = this.getDiscountValue(item.value, item.baseUnitariaICMS, item.auxCount);

      item.totalValue = Number(item.totalValue) - Number(item.discountValue);
      item.valIcms = Number(item.totalValue) * (Number(item.icms) / 100);
    });

    return list;
  }

  getUnitBaseICMS(baseICMS, qtdFaturada) {
    if (!baseICMS || !qtdFaturada) return 0;
    return Number(Number(baseICMS) / Number(qtdFaturada));
  }

  getDiscountValue(value, baseUnitariaICMS, auxCount) {
    if (!value || !baseUnitariaICMS || !auxCount) return 0;

    let discountValue = Number(value) - baseUnitariaICMS;

    if (discountValue <= 0 || !discountValue) discountValue = 0;

    return Number(discountValue) * Number(auxCount);
  }

  validateKit(i) {
    /* Monta os tipos possíveis de KIT */
    const types = [];
    this._kitPossibilities.types.map(type => this._kitPossibilities.sizes.map(size => types.push({
      concat: type.concat(size),
      string: type,
      number: size,
    })));

    types.forEach(type => {
      if (i.description.toUpperCase().includes(type.concat) && !i.edited) {
        i.value = Number(i.value) / Number(type.number);
        i.edited = true;
      }
    });

    return i;
  }

  nfeGetTotalValue(products) {
    let value = 0;

    if (!products || products.length === 0) return value;

    products.forEach(item => {
      value += Number(item.totalValue);
    });
    return value;
  }

  nfeGetTotalProductsValue(products) {
    let value = 0;

    if (!products || products.length === 0) return value;

    products.forEach(item => {
      value += Number(item.totalValue);
    });
    value = Number(value) + Number(this.nfeGetTotalDiscountValue(products));
    return value;
  }

  nfeGetTotalDiscountValue(products) {
    let value = 0;

    if (!products || products.length === 0) return value;

    products.forEach(item => {
      value += Number(item.discountValue);
    });
    return value;
  }

  nfeGetTotalBcIcms(products) {
    let value = 0;

    if (!products || products.length === 0) return value;

    products.forEach(item => {
      value += Number(item.totalValue);
    });
    return value;
  }

  nfeGetTotalIcms(products) {
    let value = 0;

    if (!products || products.length === 0) return value;

    products.forEach(item => {
      value += Number(item.valIcms);
    });
    return value;
  }

  getNfList(products) {
    const nfList = [];

    products.forEach(item => {
      if (!nfList.find(i => i.nf == item.nf)) nfList.push({ nf: item.nf, dateNf: item.dateNf });
    });

    return nfList;
  }

  nfeConvertCfop(cfop, convertCfop) {
    const res = convertCfop.find(i => i.from == cfop);
    if (!res) return '';
    return res.to || '';
  }
}
